import ErrorPopup from './ErrorPopup';

export default ErrorPopup;



// WEBPACK FOOTER //
// ./src/components/ErrorPopup/index.js